import { jsPDF } from "jspdf";
import { CHECKLIST_ITEMS, SITE } from "../data/site";

export const downloadChecklistPdf = () => {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const W = doc.internal.pageSize.getWidth();
  const M = 56;

  doc.setFillColor(6, 11, 20);
  doc.rect(0, 0, W, 150, "F");
  doc.setFillColor(0, 229, 89);
  doc.rect(0, 150, W, 4, "F");

  doc.setTextColor(0, 229, 89);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.text("TOP EMAIL MARKETING TOOLS", M, 60);
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(26);
  doc.text("The 10-Point Email Marketing Checklist", M, 95);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  doc.setTextColor(160, 171, 192);
  doc.text("Run this before every campaign launch. Print it. Stick it on your wall.", M, 122);

  let y = 205;
  CHECKLIST_ITEMS.forEach((item, i) => {
    doc.setDrawColor(0, 229, 89);
    doc.setLineWidth(1.4);
    doc.rect(M, y - 11, 13, 13);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);
    doc.setTextColor(6, 11, 20);
    doc.text(`${String(i + 1).padStart(2, "0")}`, M + 24, y);
    doc.setFont("helvetica", "normal");
    doc.text(item, M + 52, y, { maxWidth: W - M * 2 - 52 });
    y += 42;
  });

  doc.setFontSize(9);
  doc.setTextColor(120, 128, 145);
  doc.text(`${SITE.name} · ${SITE.tagline} · topemailmarketingtools.com`, M, y + 30);

  doc.save("email-marketing-checklist.pdf");
};

export const downloadNotionTemplate = () => {
  const md = [
    "# The 10-Point Email Marketing Checklist",
    "",
    "> Paste this into Notion — it converts to a to-do list automatically.",
    "> Run it before every campaign launch.",
    "",
    ...CHECKLIST_ITEMS.map((item) => `- [ ] ${item}`),
    "",
    "---",
    `*${SITE.name} — ${SITE.tagline}*`,
  ].join("\n");
  const blob = new Blob([md], { type: "text/markdown" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "email-marketing-checklist-notion.md";
  a.click();
  URL.revokeObjectURL(url);
};
